module.exports = __webpack_public_path__ + "img/CarolynMacKenzie.378b2829.jpg";